import React from 'react';
//MUI imports
import {
  Tabs,
  createStyles,
  useTheme,
  Tab,
  Box,
  Typography,
  makeStyles,
  Theme,
} from '@material-ui/core';

import SwipeableViews from 'react-swipeable-views';
import { ActiveDriversMobView } from './activeDriversMobView';
import { useQueryClient, useQuery } from 'react-query';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabLabels: {
      textOverflow: 'ellipsis',
      flexShrink: 0,
      flexBasis: 'content',
    },
    driverMobView: {
      paddingLeft: '0px',
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      right: '0',
      borderBottom: '1',
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',
    },
  })
);

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full - width - tabpanel - ${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const SecurityTabPanel = (props: { filter: string | null }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  function a11yProps(index: any) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  //Tab usage Handlers
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
  };

  return (
    <React.Fragment>
      <div className={classes.tabs}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab className={classes.tabLabels} label={` به مرکز رسیده`} {...a11yProps(0)} />
          <Tab className={classes.tabLabels} label={props.filter === "PARCEL" ? "تخلیه شده" : `اتمام بارگیری`} {...a11yProps(1)} />
          <Tab className={classes.tabLabels} label={`همه`} {...a11yProps(2)} />
          {/* <Tab className={classes.tabLabels} label={`در انتظار بارگیری`} {...a11yProps(2)} /> */}
        </Tabs>
      </div>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
        style={{ marginTop: "50px" }}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <ActiveDriversMobView className={classes.driverMobView} status="ENTERED" filter={props.filter} />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <ActiveDriversMobView className={classes.driverMobView} status="LOADED" filter={props.filter} />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          <ActiveDriversMobView className={classes.driverMobView} status="" filter={props.filter} />
        </TabPanel>
        {/* <TabPanel value={value} index={2} dir={theme.direction}>
          <ActiveDriversMobView className={classes.driverMobView} status="WAITING" filter={props.filter} />
        </TabPanel> */}

      </SwipeableViews>
    </React.Fragment>
  );
};
